import { memo } from 'react';
import { LinkContainer } from 'react-router-bootstrap';

import Button from './Button';
import type { ButtonProps } from './utils';

/** Пропсы route-кнопки: базовые пропсы Button + маршрут навигации. */
export interface RouteButtonProps extends ButtonProps {
  /** Маршрут для LinkContainer (react-router). */
  to: string;
}

const RouteButton = ({
  to,
  children,
  ...rest
}: RouteButtonProps) => {
  return (
    <LinkContainer to={ to }>
      <Button variant='primary' { ...rest }>
        { children }
      </Button>
    </LinkContainer>
  );
};

export default memo(RouteButton);
